module.exports = __webpack_public_path__ + "static/media/checkmark.a5813583.svg";